var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9706 15.0725V43.7232H12.662V15.0725H43.9706ZM46.6326 12.4102H10V46.3856H46.6401V12.4102H46.6326Z",
    fill: "#C4CFF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6401 12.4102H10V20.1431H46.6401V12.4102Z",
    fill: "#9BABD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4965 12.9936H16.8345V10.3312C16.8345 9.59829 17.4327 9 18.1655 9C18.8983 9 19.4965 9.59829 19.4965 10.3312V12.9936Z",
    fill: "#4A567A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.651 12.9936H26.989V10.3312C26.989 9.59829 27.5872 9 28.32 9C29.0528 9 29.651 9.59829 29.651 10.3312V12.9936Z",
    fill: "#4A567A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8056 12.9936H37.1436V10.3312C37.1436 9.59829 37.7418 9 38.4746 9C39.2074 9 39.8056 9.59829 39.8056 10.3312V12.9936Z",
    fill: "#4A567A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4685 22.6719H15.8623V27.2787H20.4685V22.6719Z",
    fill: "#C4CFF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2356 22.6719H22.6294V27.2787H27.2356V22.6719Z",
    fill: "#C4CFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0029 22.6719H29.3967V27.2787H34.0029V22.6719Z",
    fill: "#C4CFF0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.77 22.6719H36.1638V27.2787H40.77V22.6719Z",
    fill: "#C4CFF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4685 29.7012H15.8623V34.308H20.4685V29.7012Z",
    fill: "#C4CFF0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2356 29.7012H22.6294V34.308H27.2356V29.7012Z",
    fill: "#C4CFF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0029 29.7012H29.3967V34.308H34.0029V29.7012Z",
    fill: "#4A567A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.77 29.7012H36.1638V34.308H40.77V29.7012Z",
    fill: "#C4CFF0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4685 36.7324H15.8623V41.3393H20.4685V36.7324Z",
    fill: "#C4CFF0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2356 36.7324H22.6294V41.3393H27.2356V36.7324Z",
    fill: "#C4CFF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0029 36.7324H29.3967V41.3393H34.0029V36.7324Z",
    fill: "#C4CFF0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.77 36.7324H36.1638V41.3393H40.77V36.7324Z",
    fill: "#C4CFF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.48cd63c0154cf85c46600cca4228c6f3.svg";
export { ForwardRef as ReactComponent };